module.exports = __webpack_public_path__ + "img/leveler-6-off.dcfc8d7d.png";